var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DataTableDeCrud',{attrs:{"hideUpdate":"","hideDetail":"","hideCreate":"","hideDelete":"","headers":_vm.headers,"items":_vm.gruposEconomicos,"footer-props":{ itemsPerPageOptions: [ 5, 10, 15, 30, 50 ] }}})}
var staticRenderFns = []

export { render, staticRenderFns }